import axios from 'axios';
import { API_ENDPOINTS } from './endpoints';

export const AuthService = {
  refreshToken: async (data) => {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}${API_ENDPOINTS.AUTH.REFRESH}`,
      data
    );
    return response;
  },

  resetPassword: async (data) => {
    const response = await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}${API_ENDPOINTS.AUTH.RESET_PASSWORD}`,
      data
    );
    return response;
  },

  forgotPassword: async (data) => {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}${API_ENDPOINTS.AUTH.FORGOT_PASSWORD}`,
      data
    );
    return response;
  },
};
